interface Step {
    title: string
    desc: string
}

interface T {
    title: string
    subtitle: string
    steps: Step[]
}

export const translations: Record<string, T> = {
    en: {
        title: 'Three steps. Ten minutes. Done.',
        subtitle:
            'No paper trading, no months of setup — your robot can be live by lunchtime.',
        steps: [
            {
                title: 'Open a trading account',
                desc: 'Sign up on Binance, Bybit, OKX or an FCM that supports Rithmic. Fund it. That is the only thing that stays with you.',
            },
            {
                title: 'Connect to RealColibri',
                desc: 'Create your free RealColibri account. Add Read & Trade-only API keys (or Rithmic login). Takes under 5 minutes.',
            },
            {
                title: 'Press Start',
                desc: 'Pick a symbol and a deposit size, press Start. The algorithm takes over from the very next tick — you keep full control to stop or change anytime.',
            },
        ],
    },
    es: {
        title: 'Tres pasos. Diez minutos. Listo.',
        subtitle:
            'Sin paper trading, sin meses de configuración — tu robot puede estar operando antes del almuerzo.',
        steps: [
            {
                title: 'Abre una cuenta de trading',
                desc: 'Regístrate en Binance, Bybit, OKX o un FCM compatible con Rithmic. Fondea. Es lo único que se queda contigo.',
            },
            {
                title: 'Conéctate a RealColibri',
                desc: 'Crea tu cuenta RealColibri gratis. Añade claves API solo Read & Trade (o login Rithmic). Menos de 5 minutos.',
            },
            {
                title: 'Pulsa Start',
                desc: 'Elige símbolo y tamaño de depósito, pulsa Start. El algoritmo toma el control desde el siguiente tick — tú mantienes el control total para detener o cambiar en cualquier momento.',
            },
        ],
    },
    ru: {
        title: 'Три шага. Десять минут. Готово.',
        subtitle:
            'Никакого paper-trading, никаких месяцев настройки — ваш робот может торговать уже сегодня к обеду.',
        steps: [
            {
                title: 'Откройте торговый счёт',
                desc: 'Зарегистрируйтесь на Binance, Bybit, OKX или FCM с поддержкой Rithmic. Пополните. Это единственное, что остаётся у вас.',
            },
            {
                title: 'Подключитесь к RealColibri',
                desc: 'Создайте бесплатный аккаунт RealColibri. Добавьте API-ключи Read & Trade (или login для Rithmic). Меньше 5 минут.',
            },
            {
                title: 'Нажмите Start',
                desc: 'Выберите символ и размер депозита, нажмите Start. Алгоритм берёт управление со следующего тика — вы сохраняете полный контроль, чтобы остановить или изменить в любой момент.',
            },
        ],
    },
    hy: {
        title: 'Երեք քայլ: Տասը րոպե: Պատրաստ:',
        subtitle:
            'Ոչ paper-trading, ոչ ամիսներով կարգավորում — ձեր ռոբոտը կարող է աշխատել արդեն այսօր ճաշից առաջ:',
        steps: [
            {
                title: 'Բացեք առևտրային հաշիվ',
                desc: 'Գրանցվեք Binance, Bybit, OKX-ում կամ Rithmic-ին աջակցող FCM-ում: Համալրեք: Սա միակ բանն է, որ մնում է ձեզ հետ:',
            },
            {
                title: 'Միացեք RealColibri-ին',
                desc: 'Ստեղծեք անվճար RealColibri հաշիվ: Ավելացրեք միայն Read & Trade API բանալիներ (կամ Rithmic login): 5 րոպեից պակաս:',
            },
            {
                title: 'Սեղմեք Start',
                desc: 'Ընտրեք սիմվոլ և դեպոզիտի չափ, սեղմեք Start: Ալգորիթմը վերցնում է կառավարումը հաջորդ tick-ից — դուք պահպանում եք լիարժեք վերահսկողություն դադարեցնելու կամ փոխելու համար ցանկացած պահի:',
            },
        ],
    },
    de: {
        title: 'Drei Schritte. Zehn Minuten. Fertig.',
        subtitle:
            'Kein Paper-Trading, keine Monate Setup — Ihr Roboter kann bis zum Mittagessen live sein.',
        steps: [
            {
                title: 'Handelskonto eröffnen',
                desc: 'Registrieren bei Binance, Bybit, OKX oder einem FCM mit Rithmic-Unterstützung. Einzahlen. Das ist das Einzige, was bei Ihnen bleibt.',
            },
            {
                title: 'Mit RealColibri verbinden',
                desc: 'Kostenloses RealColibri-Konto erstellen. Read & Trade API-Schlüssel hinzufügen (oder Rithmic-Login). Unter 5 Minuten.',
            },
            {
                title: 'Start drücken',
                desc: 'Symbol und Deposit-Größe wählen, Start drücken. Der Algorithmus übernimmt ab dem nächsten Tick — Sie behalten die volle Kontrolle, um jederzeit zu stoppen oder zu ändern.',
            },
        ],
    },
    fr: {
        title: 'Trois étapes. Dix minutes. Terminé.',
        subtitle:
            'Pas de paper-trading, pas de mois de configuration — votre robot peut être en live avant le déjeuner.',
        steps: [
            {
                title: 'Ouvrez un compte de trading',
                desc: 'Inscrivez-vous sur Binance, Bybit, OKX ou un FCM compatible Rithmic. Approvisionnez. C\'est la seule chose qui reste avec vous.',
            },
            {
                title: 'Connectez-vous à RealColibri',
                desc: 'Créez votre compte RealColibri gratuit. Ajoutez des clés API Read & Trade uniquement (ou login Rithmic). Moins de 5 minutes.',
            },
            {
                title: 'Appuyez sur Start',
                desc: 'Choisissez un symbole et la taille du dépôt, appuyez sur Start. L\'algorithme prend le relais dès le tick suivant — vous gardez le contrôle total pour arrêter ou modifier à tout moment.',
            },
        ],
    },
    it: {
        title: 'Tre passi. Dieci minuti. Fatto.',
        subtitle:
            'Niente paper-trading, niente mesi di setup — il tuo robot può essere live prima di pranzo.',
        steps: [
            {
                title: 'Apri un conto di trading',
                desc: 'Registrati su Binance, Bybit, OKX o un FCM che supporta Rithmic. Fondi. È l\'unica cosa che resta con te.',
            },
            {
                title: 'Collegati a RealColibri',
                desc: 'Crea il tuo account RealColibri gratuito. Aggiungi chiavi API solo Read & Trade (o login Rithmic). Meno di 5 minuti.',
            },
            {
                title: 'Premi Start',
                desc: 'Scegli simbolo e dimensione del deposito, premi Start. L\'algoritmo prende il controllo dal tick successivo — mantieni il pieno controllo per fermare o cambiare in qualsiasi momento.',
            },
        ],
    },
}
